import React from 'react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-136">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-137">
        <div className="bg-emerald-50 border border-emerald-200 rounded-3xl p-8 md:p-10 text-center" data-id="element-138">
          <div className="text-5xl mb-4" data-id="element-139">🛡️</div>
          <h2 className="font-display text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-140">
            Probalo sin riesgo
          </h2>
          <p className="text-lg text-gray-700 mb-6 max-w-md mx-auto" data-id="element-141">
            Tenés <span className="font-bold text-emerald-700" data-id="element-142">7 días completos</span> para probarlo. Si no notás nada diferente, te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin vueltas.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3 text-sm font-semibold mb-8" data-id="element-143">
            {['Sin riesgo', 'Sin preguntas', 'Devolución inmediata'].map((item, i) => <div key={i} className="flex items-center justify-center gap-2 bg-white border border-emerald-200 px-4 py-2 rounded-full text-emerald-800" data-id="element-144">
                <span data-id="element-145">✓</span> {item}
              </div>)}
          </div>
          <CTAButton size="large" data-id="element-146">EMPEZAR — $16.990</CTAButton>
          <p className="text-xs text-gray-400 mt-3" data-id="element-147">Acceso inmediato · Garantía 7 días</p>
        </div>
      </div>
    </section>;
}